import { Component, OnInit, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { PaymentTermsService } from 'app/services/payment-terms.service';
import { GlobalSearchService } from 'app/services/globalsearchservice.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';
import { interval, Subscription, Subject, of } from 'rxjs';
import { switchMap, catchError, takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-batch-dashboard',
	templateUrl: './batch-dashboard.component.html',
	styleUrls: ['./batch-dashboard.component.scss']
})
export class BatchDashboardComponent implements OnInit, OnDestroy {
	batchHistory: any[] = [];
	currentBatch: any = null;
	attempts: any[] = [];
	loading = false;
	processing = false;
	statusPolling: Subscription | null = null;
	color = 'blue';
	config: any = [];
	selectedcust: any  = [];
	@ViewChild('cardModal') cardModalRef: ElementRef;
	@ViewChild('invoiceModal') invoiceModalRef: ElementRef;
	private destroy$ = new Subject<void>();
	
	// Preview/Configuration mode
	previewMode = false;
	previewCustomers: any[] = [];
	previewLoading = false;
	selectedCustomers: Set<string> = new Set();

	// Payment terms selection
	availableTerms: any[] = [];
	selectedTermCodes: string[] = [];
	termsLoading = false;
	agingBucket = 'overdue1';
	
	customerdata: any = false;
	arpreauth = false;

	agingBuckets = [
		{ value: 'overdue1', label: '30+ days' },
		{ value: 'overdue2', label: '60+ days' },
		{ value: 'overdue3', label: '90+ days' }
	];

	constructor(
        private paymentTermsService: PaymentTermsService,
        private globalSearchService: GlobalSearchService,
        private location: Location,
		private modalService: NgbModal
	) { 
	this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;

			if (this.config.arpreauth) {
				this.arpreauth = this.config.arpreauth;
			}

	
	});
	
	}

	ngOnInit(): void {
		this.color = this.globalSearchService.getColor();
		this.loadBatchHistory();
		this.loadAvailableTerms();
	}

	loadAvailableTerms(): void {
		this.termsLoading = true;
		this.paymentTermsService.getPaymentTerms().subscribe(
			(response: any) => {
				this.termsLoading = false;
				console.log('Payment terms API response:', response);
				if (response && response.success !== false && response.terms) {
					this.availableTerms = Array.isArray(response.terms) ? response.terms : [];
					if (this.availableTerms.length > 0) {
						this.selectedTermCodes = this.availableTerms.map((term: any) => term.termsindicator);
					}
				} else {
					console.warn('Invalid response or no terms:', response);
					this.availableTerms = [];
				}
			},
			(error: any) => {
				console.error('Error loading payment terms:', error);
				this.termsLoading = false;
				this.availableTerms = [];
			}
		);
	}

	back(): void {
		this.location.back();
	}
/*
	ngOnDestroy(): void {
		if (this.statusPolling) {
			this.statusPolling.unsubscribe();
		}
	}
*/
	ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.statusPolling) {
        this.statusPolling.unsubscribe();
    }
}

	loadBatchHistory(): void {
		this.loading = true;
		this.paymentTermsService.getBatchHistory({ limit: 20 }).subscribe(
			(response: any) => {
				if (response.success && response.batch_logs) {
					this.batchHistory = response.batch_logs;
				}
				this.loading = false;
			},
			(error: any) => {
				console.error('Error loading batch history:', error);
				this.loading = false;
			}
		);
	}

	runBatch(): void {
		if (this.processing) {
			return;
		}

		this.processing = true;
		this.paymentTermsService.runBatch().subscribe(
			(response: any) => {
				if (response.success) {
					this.currentBatch = {
						id: response.batch_log_id,
						status: 'running',
						...response
					};
					this.loadBatchHistory();
					this.startStatusPolling(response.batch_log_id);
				} else {
					alert('Error starting batch: ' + (response.error || 'Unknown error'));
					this.processing = false;
				}
			},
			(error: any) => {
				console.error('Error running batch:', error);
				alert('Error starting batch. Please try again.');
				this.processing = false;
			}
		);
	}
/*
	startStatusPolling(batchLogId: number): void {
		if (this.statusPolling) {
			this.statusPolling.unsubscribe();
		}

		this.statusPolling = interval(2000).subscribe(() => {
			this.paymentTermsService.getBatchStatus(batchLogId).subscribe(
				(response: any) => {
					if (response.success && response.batch_log) {
						this.currentBatch = response.batch_log;

						if (response.batch_log.status !== 'running') {
							this.processing = false;
							if (this.statusPolling) {
								this.statusPolling.unsubscribe();
								this.statusPolling = null;
							}
							this.loadBatchHistory();
						}
					}
				},
				(error: any) => {
					console.error('Error polling status:', error);
				}
			);
		});
	}
*/
	startStatusPolling(batchLogId: number): void {
    if (this.statusPolling) {
        this.statusPolling.unsubscribe();
    }

    this.statusPolling = interval(7000).pipe(
        takeUntil(this.destroy$),
        switchMap(() => this.paymentTermsService.getBatchStatus(batchLogId).pipe(
            catchError(err => {
                console.error('Error polling status:', err);
                return of(null); // keep polling on error, don't kill the interval
            })
        ))
    ).subscribe((response: any) => {
        if (!response) { return; }

        if (response.success && response.batch_log) {
            this.currentBatch = response.batch_log;

            if (response.batch_log.status !== 'running') {
                this.processing = false;
                this.statusPolling.unsubscribe();
                this.statusPolling = null;
                this.loadBatchHistory();
            }
        }
    });
}

	viewAttempts(batchLogId: number): void {
		this.paymentTermsService.getAttempts(batchLogId).subscribe(
			(response: any) => {
				if (response.success && response.attempts) {
					this.attempts = response.attempts;
				}
			},
			(error: any) => {
				console.error('Error loading attempts:', error);
			}
		);
	}

	getStatusColor(status: string): string {
		switch (status) {
		case 'completed': return 'success';
		case 'running': return 'warning';
		case 'failed': return 'danger';
		default: return 'secondary';
		}
	}

	getStatusBadgeClass(status: string): string {
		switch (status) {
		case 'success': return 'badge-success';
		case 'failed': return 'badge-danger';
		case 'pending': return 'badge-secondary';
		case 'expired_card': return 'badge-warning';
		case 'no_card': return 'badge-info';
		default: return 'badge-secondary';
		}
	}

	formatCurrency(amount: any): string {
		if (!amount) {return '$0.00';}
		const num = parseFloat(amount);
		return '$' + num.toFixed(2);
	}

	formatDate(dateStr: string): string {
		if (!dateStr) {return '';}
		const date = new Date(dateStr);
		return date.toLocaleString();
	}

	loadCustomersByTerms(): void {
		if (this.selectedTermCodes.length === 0) {
			alert('Please select at least one payment term to process.');
			return;
		}

		this.previewLoading = true;
		this.paymentTermsService.loadCustomers(this.selectedTermCodes, this.agingBucket).subscribe(
			(response: any) => {
				if (response.success && response.customers) {
					this.previewCustomers = response.customers.map((cust: any) => ({
						...cust,
						selected: cust.cards && cust.cards.length > 0 ? true : false,
						selectedCardId: cust.cards && cust.cards.length > 0 ? cust.cards[0].card_id : null,
						amount: cust.overdue_balance || 0
					}));
					this.selectedCustomers.clear();
					this.previewCustomers.forEach((cust: any) => {
						if (cust.selected) {
							this.selectedCustomers.add(cust.debtorno + '_' + cust.branchcode);
						}
					});
					this.previewMode = true;
				}
				this.previewLoading = false;
			},
			(error: any) => {
				console.error('Error loading customers:', error);
				alert('Error loading customers. Please try again.');
				this.previewLoading = false;
			}
		);
	}

	toggleCustomer(customer: any): void {
		const key = customer.debtorno + '_' + customer.branchcode;
		if (this.selectedCustomers.has(key)) {
			this.selectedCustomers.delete(key);
			customer.selected = false;
		} else {
			this.selectedCustomers.add(key);
			customer.selected = true;
		}
	}
	
	toggleCustomerInvoice(customer: any, invoice: any): void {
		const index = this.previewCustomers.indexOf(customer);
		const invoiceindex = this.previewCustomers[index].overdue_invoices.indexOf(invoice);
		
		if(this.previewCustomers[index].overdue_invoices[invoiceindex].selected){
		this.previewCustomers[index].overdue_invoices[invoiceindex].selected = false;
		} else {
		this.previewCustomers[index].overdue_invoices[invoiceindex].selected = true;
		
		}
		this.recalcAmounts();
	}
	
	recalcAmounts(){
	
		this.previewCustomers.forEach((cust: any) => {
		
		cust.amount = this.rollupInvoices(cust.overdue_invoices);
			
		});
		
		this.selectedCustomers.clear();
					this.previewCustomers.forEach((cust: any) => {
						if (cust.selected) {
							this.selectedCustomers.add(cust.debtorno + '_' + cust.branchcode);
						}
					});
	}
	
	rollupInvoices(invoices: any){
	
		let total = 0;
		invoices.forEach((inv: any) => {
			if(inv.selected){
			total = total + parseFloat(inv.overdue_balance);		
			}
		});
		
		return this.financial(total);
	}

	selectAllCustomers(): void {
		this.previewCustomers.forEach((cust: any) => {
			cust.selected = true;
			this.selectedCustomers.add(cust.debtorno + '_' + cust.branchcode);
		});
	}

	deselectAllCustomers(): void {
		this.previewCustomers.forEach((cust: any) => {
			cust.selected = false;
		});
		this.selectedCustomers.clear();
	}

	processSelectedCustomers(): void {
		if (this.processing) {
			return;
		}

		if (this.selectedCustomers.size === 0) {
			alert('Please select at least one customer to process.');
			return;
		}

		const customersToProcess: any[] = [];
		const errors: string[] = [];

		this.previewCustomers
			.filter((cust: any) => cust.selected && this.selectedCustomers.has(cust.debtorno + '_' + cust.branchcode))
			.forEach((cust: any) => {
				if (!cust.selectedCardId || cust.selectedCardId === null) {
					errors.push(`${cust.debtorno}.${cust.branchcode}: No card selected`);
					return;
				}

				const amount = parseFloat(cust.amount) || 0;
				if (amount <= 0) {
					errors.push(`${cust.debtorno}.${cust.branchcode}: Amount must be greater than 0`);
					return;
				}
				//get card details for selected Card
				let cardindex = cust.cards.indexOf
				customersToProcess.push({
					debtorno: cust.debtorno,
					branchcode: cust.branchcode,
					name: cust.name,
					card_id: cust.selectedCardId,
					cards: cust.cards,
					invoices: cust.overdue_invoices,
					amount: amount
				});
			});

		if (errors.length > 0) {
			alert('Please fix the following errors before processing:\n\n' + errors.join('\n'));
			return;
		}

		if (customersToProcess.length === 0) {
			alert('No valid customers to process. Please check your selections.');
			return;
		}

		if (!confirm(`Process payments for ${customersToProcess.length} customer(s)?`)) {
			return;
		}

		this.processing = true;
		this.paymentTermsService.runBatchConfigured(customersToProcess).subscribe(
			(response: any) => {
				if (response.success) {
					this.currentBatch = {
						id: response.batch_log_id,
						status: 'running',
						...response
					};
					this.previewMode = false;
					this.loadBatchHistory();
					this.startStatusPolling(response.batch_log_id);
				} else {
					alert('Error processing payments: ' + (response.error || 'Unknown error'));
					this.processing = false;
				}
			},
			(error: any) => {
				console.error('Error processing customers:', error);
				alert('Error processing payments. Please try again.');
				this.processing = false;
			}
		);
	}

	cancelPreview(): void {
		this.previewMode = false;
		this.previewCustomers = [];
		this.selectedCustomers.clear();
	}

	getCardDisplay(card: any): string {
		if (!card) {return 'No Card';}
		return `${card.card_function || 'Card'} - ${card.description} - ${card.expiry_month}/${card.expiry_year}`;
	}

	getSelectedCount(): number {
		return this.previewCustomers.filter((c: any) => c.selected).length;
	}

	getSelectedTotalAmount(): number {
		return this.previewCustomers
			.filter((c: any) => c.selected)
			.reduce((sum: number, c: any) => sum + (parseFloat(c.amount) || 0), 0);
	}
	
	addCard(customer: any){
	
	this.selectedcust = customer;
	this.modalService.open(this.cardModalRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result: any) => {

			}, (reason) => {
				
			});
			
	}
	showInvoices(customer: any){
	this.selectedcust = customer;
	this.modalService.open(this.invoiceModalRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result: any) => {

			}, (reason) => {
				
			});
			
	}
	
	refreshCards(event: any){
		event.cards.forEach((e) => {
		e.description = e.name;
		});
		const index = this.previewCustomers.indexOf(this.selectedcust);
		this.previewCustomers[index].cards = event.cards;
		this.previewCustomers[index].selected = true;
		this.previewCustomers[index].selectedCardId = this.previewCustomers[index].cards && this.previewCustomers[index].cards.length > 0 ? this.previewCustomers[index].cards[0].card_id : null;
		
		this.selectedCustomers.clear();
					this.previewCustomers.forEach((cust: any) => {
						if (cust.selected) {
							this.selectedCustomers.add(cust.debtorno + '_' + cust.branchcode);
						}
					});
		this.modalService.dismissAll();
	}
	
	
	financial(num: number): number {

		if (!num) {
			num = 0.00;
		}
		const rounded = Math.round((num + Number.EPSILON) * 100) / 100;
		return parseFloat(rounded.toFixed(2));
	}
}


